import Vue from 'vue'
import Vuex from 'vuex'

import global from './modules/global'
import popup from './modules/popup'
import popupWithInput from './modules/popupWithInput'
import popupWithSelectbox from './modules/popupWithSelectbox'
import auth from './modules/auth'
import user from './modules/user'
import userSettings from './modules/user-settings'
import layout from "@/store/modules/layout"

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		global,
		popup,
		popupWithInput,
		popupWithSelectbox,
		auth,
		user,
		userSettings,
		layout,
	},
	strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js